import VariableStep from './VariableStep';
import './VariableStep.scss';

export default VariableStep;
